import React from "react";

const TrophyModal = React.memo(({ isOpen, onClose, onShowReport, scoreStatus, trophyTitle, t }) => {
    if (!isOpen) return null;

    // Determine icon and explanation text based on scoreStatus
    let statusIcon = "fas fa-crown text-warning";
    let explanationText = t("Pages.Chatbot.TrophyExcellentText");
    let statusClass = "excellent";

    if (scoreStatus === "VeryGood") {
        statusIcon = "fas fa-medal text-primary";
        explanationText = t("Pages.Chatbot.TrophyVeryGoodText");
        statusClass = "very-good";
    } else if (scoreStatus === "Acceptable") {
        statusIcon = "fas fa-thumbs-up text-success";
        explanationText = t("Pages.Chatbot.TrophyAcceptableText");
        statusClass = "acceptable";
    } else if (scoreStatus === "NeedFocus") {
        statusIcon = "fas fa-book-reader text-info";
        explanationText = t("Pages.Chatbot.TrophyNeedFocusText");
        statusClass = "need-focus";
    }

    return (
        <div className="modal-overlay active animate__animated animate__fadeIn" id="next-stage-modal" onClick={onClose}>
            <div className={`chatbot-modal-content trophy-modal-${statusClass} animate__animated animate__zoomIn`} onClick={(e) => e.stopPropagation()}>
                <div className="trophy-icon"><i className={statusIcon}></i></div>
                <h2>{trophyTitle}</h2>
                <div className="rule-explanation">
                    {explanationText}
                </div>
                <button
                    className="btn-primary-deep"
                    onClick={() => {
                        onClose();
                        onShowReport();
                    }}
                >
                    {t("Pages.Chatbot.ShowReport")} <i className="fal fa-arrow-left"></i>
                </button>
            </div>
        </div>
    );
});

export default TrophyModal;
